import { of, race, timer } from 'rxjs';
import {
  map, switchMap, catchError, take,
} from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { createAction } from 'redux-actions';
import { types } from '..';
import { constants as ipmConstants } from '../ipm-constants';
import { getParameterByName } from '../../../../util/misc/target-finder';
import { getCookie } from '../../../../util/misc/cookie-helper';
import { constants as loginConstants } from '../../../../components/login/login-comp-constants';
import { ADP_LANG_LOCALE_COOKIE } from '../../../../util/locale';

const { CALLING_APP_ID_BROWSER_LABEL } = loginConstants;
const { IPM_CONTENT_ENDPOINT, CONTENT_TYPE_JSON, IPM_LOAD_TIMEOUT_MS } = ipmConstants;

const { LOAD_IPM_CONTENT_REQUEST, LOAD_IPM_CONTENT_FAIL, SET_IPM_CONTENT } = types;

const loadIpmContentFailEvent = createAction(LOAD_IPM_CONTENT_FAIL);
const setIpmContentEvent = createAction(SET_IPM_CONTENT);

function getIpmUrl() {
  try {
    const baseUrl = window.env && window.env.IPM_CONTENT_SERVICE
      ? window.env.IPM_CONTENT_SERVICE
      : IPM_CONTENT_ENDPOINT;

    const callingAppId = getParameterByName(CALLING_APP_ID_BROWSER_LABEL) || '';
    const locale = getCookie(ADP_LANG_LOCALE_COOKIE)
      ? getCookie(ADP_LANG_LOCALE_COOKIE).replace(/[_]/, '-')
      : 'en-US';

    return `${baseUrl}?callingAppId=${encodeURIComponent(callingAppId)}&locale=${encodeURIComponent(locale)}`;
  } catch {
    return IPM_CONTENT_ENDPOINT;
  }
}

const handleIpmResponse = (response) => {
  const { status } = response.response;

  if (status === 200) {
    const { content } = response.response.response || {};

    if (content) {
      // eslint-disable-next-line no-console
      console.log('[IPM] Marketing content loaded successfully');
      return setIpmContentEvent({
        ipmContent: content,
        ipmContentLoaded: true,
      });
    }
  }
  // eslint-disable-next-line no-console
  console.log('[IPM] No marketing content available, status:', status);
  return setIpmContentEvent({ ipmContent: null, ipmContentLoaded: true });
};

const loadIpmContentService = (ajax) => ajax({
  url: getIpmUrl(),
  headers: { 'Content-Type': CONTENT_TYPE_JSON },
  method: 'get',
}).pipe(
  map((response) => handleIpmResponse({ response })),
  catchError((err) => {
    // eslint-disable-next-line no-console
    console.log('[IPM] Error loading marketing content:', err && err.status);
    return of(loadIpmContentFailEvent());
  }),
);

export const loadIpmContentEpic = (action$, state$, { ajax }) => action$.pipe(
  ofType(LOAD_IPM_CONTENT_REQUEST),
  switchMap(() => race(
    loadIpmContentService(ajax),
    timer(IPM_LOAD_TIMEOUT_MS).pipe(
      take(1),
      map(() => {
        // eslint-disable-next-line no-console
        console.log(
          '[IPM] Marketing content request timed out after 3 seconds',
        );
        return setIpmContentEvent({
          ipmContent: null,
          ipmContentLoaded: true,
        });
      }),
    ),
  )),
);
